import angular from "angular";
import wsStoreTemplate from './wsStore.html';

LowercaseDirective.$inject = [];

/*******************************************************************************
* @ngdoc   component
* @mdule   csm.ui.webStore
* @name    csm.ui.webStore.component:wsStore
*
* @param {object}  data  App data read from server.
*
* @description
* This component displays the store tab of the webStore admin page. It also
* diplays the store design page in a modal so design changes can be made and changed.
*******************************************************************************/
export const wsStoreComponent = {
  bindings: { data: '<' },
  template: wsStoreTemplate,
  controller: WSStoreController
};


/*****************************************************************************
 * lowercase */
/**
 * Updates text coming from ngModel to lowercase.
 * Note: This is coming from someone's answer on StackOverflow, and converted
 * to be lowercase.
 * https://stackoverflow.com/questions/16388562/angularjs-force-uppercase-in-textbox
 *****************************************************************************/
/* @ngInject */ export function LowercaseDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, modelCtrl) {
      var lowercase = function (inputValue) {
        if (inputValue == undefined) inputValue = '';

        var lowercased = inputValue.toLowerCase();
        if (lowercased !== inputValue) {
          /*------------------------------------*/
          /* see where the cursor is before the */
          /* update so that we can set it back  */
          /*------------------------------------*/
          var selection = element[0].selectionStart;
          modelCtrl.$setViewValue(lowercased);
          modelCtrl.$render();

          /*-------------------------------------*/
          /* set back the cursor after rendering */
          /*-------------------------------------*/
          element[0].selectionStart = selection;
          element[0].selectionEnd = selection;
        }

        return lowercased;
      };
      modelCtrl.$parsers.push(lowercase);
      lowercase(scope[attrs.ngModel]); // lowercase initial value
    }
  }
}

/*****************************************************************************
 * Controller: WSStoreController
 *
 * Controller for the organization info and payment processors.
 *****************************************************************************/
/* @ngInject */ function WSStoreController($injector, $scope) {
  /** Self Reference. */ var $ctrl = this;
  /** iOS Device Indicator */ $ctrl.isIosDevice =
    $injector.invoke(isIOSDevice);

  /*---------*/
  /* Methods */
  /*---------*/
  $ctrl.copyText = $injector.invoke(copyText, null, { $ctrl: $ctrl });
  $ctrl.openStore = $injector.invoke(openStore, null, { $ctrl: $ctrl });

  /*---------*/
  /* Watches */
  /*---------*/
  $injector.invoke(watchDomainName, null, { $scope: $scope, $ctrl: $ctrl });
  $injector.invoke(watchProcessorID, null, { $scope: $scope, $ctrl: $ctrl });
}

/*****************************************************************************
 * copyText
 *
 * Copies the store link as text to the clipboard. Mobile devices will not
 * copy the text, instead they will have a link to the web site.
 *****************************************************************************/
/* @ngInject */ function copyText(Alert, UserAgent, $ctrl) {
  return function (url) {
    /*-------------------------------------------------------*/
    /* If the browser is IE, copy the text to the clipboard. */
    /*-------------------------------------------------------*/
    if (UserAgent.isIE()) {
      window.clipboardData.setData('Text', url);
      Alert.info(
        'Your URL has been copied onto your clipboard',
        'Link Copied'
      );
    } else {
      /*--------------------------------------------------------------------*/
      /* For all others, create an input element and display it off the     */
      /* screen, copy the text to the clipboard and remove the element from */
      /* the DOM. The element must be an input in order to copy the text.   */
      /*--------------------------------------------------------------------*/
      var angInput = angular.element(
        "<input type='text' style='position:absolute'>"
      );
      angInput.val(url);
      angInput.css(
        'right',
        '-' + (Math.max(window.innerWidth, window.innerHeight) + 1000) + 'px'
      );

      var body = document.querySelector('body');
      body.appendChild(angInput[0]);
      angInput[0].select();
      document.execCommand('Copy');
      body.removeChild(angInput[0]);
      Alert.info(
        'Your URL has been copied onto your clipboard',
        'Link Copied'
      );
    }
  };
}

/* @ngInject */ function isIOSDevice(UserAgent) {
  return UserAgent.isIOSDevice();
}

/*****************************************************************************
 * openStore
 *
 * Opens the design store modal.
 *****************************************************************************/
/* @ngInject */ function openStore(DesignStoreDialog, $ctrl) {
  return function () {
    DesignStoreDialog.show($ctrl.data.store, `${$ctrl.domainNameLink}?dm`);
  };
}

/*-------------------------------------------------*/
/* Watches the req.domainName property and creates */
/* the url to display in the store link field.     */
/*-------------------------------------------------*/
/* @ngInject */ function watchDomainName($scope, $ctrl) {
  $scope.$watch('$ctrl.data.store.siteDomain', function (name) {
    $ctrl.domainNameLink = !!name
      ? `${window.document.location.protocol}//${name}.${$ctrl.data.hostDomain}`
      : null;
  });
}

/*-----------------------------------------------------------------------------------*/
/* Watch the processorID. If the processor does not have a fee income account        */
/* associated with it, disable the convenience fee fields and set them to 0. When    */
/* setting up a new payment processor a convenience fee account is required, however */
/* there are some that were set up prior to the new process and do not have an       */
/* account associated with the processor. Having an amount in the convenience fee    */
/* fields without an account will prevent the web store from creating a receipt, but */
/* the charges will go through on the card. This check prevents that from happening. */
/*-----------------------------------------------------------------------------------*/
/* @ngInject */ function watchProcessorID($scope, $ctrl) {
  $scope.$watch('$ctrl.data.store.config.processorID', function (id) {
    if (!id) return;

    /*--------------------------------------------*/
    /* Clear convenience fee settings with the    */
    /* processor is not using the convenience fee */
    /*--------------------------------------------*/
    var proc =
      $ctrl.data.processors.find(function (p) {
        return p.id == id;
      }) || {};

    if (($ctrl.disableCF = proc.disableCF)) {
      $ctrl.data.store.config.convenienceFeeFixed = 0;
      $ctrl.data.store.config.convenienceFeePercent = 0;
    }
  });
}
